import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { ToggleCoworkerStatus } from "./components/coworker_toggle_action";
import { DeleteCoworkerAction } from "./components/coworker_delete_action";
import { ResetPasswordAction } from "./components/reset_password_action";

import { DataTable } from "../../components/data-table";
import { Button, Modal, Tooltip } from "flowbite-react";

import * as actions from "../../actions/index";
import {
  CREATECOWORKER_RESPONSE,
  DELETECOWORKER_RESPONSE,
  EDITCOWORKER_RESPONSE,
  TOGGLECOWORKER_RESPONSE,
} from "../../constants/action_types";

import { Popup } from "../../components/pop-up";
import { CoworkerForm, useCoworkerForm } from "./components/coworker_form";
import { FlatButton, IconButton } from "../../components/buttons";
import { ACL } from "../../components/acl";
import { SUPERADMIN } from "../../constants/roles";

function Coworkers() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const coworkersList = useSelector((state) => state?.coworker?.list);
  const coworkersListUpdated = useSelector(
    (state) => state?.coworker?.update_response
  );

  const [qrCode, setQRcode] = useState();
  const [modalState, setModalState] = useState();

  const [formModalState, setFormModalState] = useState();
  const [coworkerFormState, setCoworkerFormState] = useState({});

  useEffect(() => {
    if (
      coworkersListUpdated?.type === TOGGLECOWORKER_RESPONSE ||
      coworkersListUpdated?.type === DELETECOWORKER_RESPONSE
    ) {
      handleFetch();
    }
    if (coworkersListUpdated?.type === CREATECOWORKER_RESPONSE) {
      setFormModalState("");
      setQRcode(coworkersListUpdated?.payload?.data);
      handleFetch();
    }
    if (coworkersListUpdated?.type === EDITCOWORKER_RESPONSE) {
      handleFetch();
      setFormModalState("");
    }
  }, [coworkersListUpdated]);

  useEffect(() => {
    if (qrCode) setModalState("pop-up");
  }, [qrCode]);

  useEffect(() => {
    coworkerFormState?.mode && setFormModalState("pop-up");
  }, [coworkerFormState]);

  const urlParams = useRef({});

  const updateCoworker = (coworker, mode) => {
    mode === "Create"
      ? dispatch(actions.CREATECOWORKER_REQ(coworker))
      : dispatch(actions.EDITCOWORKER_REQ(coworker));
  };

  const coworkerForm = useCoworkerForm(
    coworkerFormState?.coworker,
    coworkerFormState?.mode,
    updateCoworker
  );

  const toggleCoworker = (cowroker) => {
    dispatch(
      actions.TOGGLECOWORKER_REQ({
        ...cowroker,
      })
    );
  };

  const deleteCoworker = (cowroker) => {
    dispatch(
      actions.DELETECOWORKER_REQ({
        ...cowroker,
      })
    );
  };

  const handleFetch = async (params) => {
    if (params) {
      urlParams.current.page = params.page || 1;
      urlParams.current.count = params.pageLimit;
      urlParams.current.sort_by = params.sortBy;
      urlParams.current.sort = params.sortDir;
      urlParams.current["filter.keyword"] = params.keyword;
    }
    dispatch(actions.GETCOWORKERS_REQ(urlParams.current));
  };

  const closeModal = () => {
    dispatch(actions.RESET_STATE("coworker.update_response"));
    setModalState(undefined);
    setQRcode(undefined);
  };

  const columns = [
    {
      name: "Employee Code",
      key: "coworker_code",
    },
    {
      name: "Name",
      key: "first_name",
      formatText: (cell, row) => {
        return `${cell || ""} ${row.last_name || ""}`;
      },
      onCellClick: (payload) => {
        navigate(`/coworkers/${payload.row.coworker_uid}/details`);
      },
    },
    { name: "Email", key: "email" },
    { name: "Primary Phone", key: "primary_phone_number" },
    { name: "Designation", key: "designation" },
    { name: "Role", key: "role" },
    {
      name: "Status",
      key: "is_active",
      formatText: (isActive) => {
        return isActive ? "Active" : "Inactive";
      },
      processClassName: (isActive) =>
        isActive ? "text-green-500 font-medium" : "text-red-500 font-medium",
    },
    {
      name: "Action",
      type: "actions",
      actions: [
        {
          element: (
            <ACL showFor={[SUPERADMIN]}>
              <Tooltip content="Edit Coworker" placement="bottom">
                <IconButton>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-4 h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
                    />
                  </svg>
                </IconButton>
              </Tooltip>
            </ACL>
          ),
          action: (data) => {
            setCoworkerFormState({ coworker: data, mode: "Edit" });
          },
        },
        {
          element: <ResetPasswordAction />,
        },
        {
          element: <ToggleCoworkerStatus onConfirm={toggleCoworker} />,
        },
        {
          element: <DeleteCoworkerAction onConfirm={deleteCoworker} />,
        },
      ],
    },
  ];

  return (
    <main class="-mt-24">
      <div class="h-full mx-auto max-w-[86rem] py-3 sm:px-6 lg:px-8">
        <div class="flex flex-1 space-x-4 h-full">
          <section
            aria-labelledby="primary-heading"
            class="flex h-full min-w-0 flex-1 flex-col lg:order-last"
          >
            <div class="h-full">
              <div class="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
                <div class="p-2 h-full ">
                  <div class="flow-root h-full ">
                    <div class="-mx-4 -my-2  overflow-x-auto sm:-mx-6 lg:-mx-8 h-full ">
                      <div class="h-full  inline-block min-w-full py-4 align-middle sm:px-6 lg:px-7">
                        <DataTable
                          name="Co-Workers"
                          enableSort={true}
                          columns={columns}
                          preserve={"all"}
                          remote={true}
                          data={coworkersList?.data}
                          totalCount={coworkersList?.total_records}
                          handleFetch={handleFetch}
                          toolbar={{
                            search: { enable: true },
                            customAction: (
                              <ACL showFor={[SUPERADMIN]}>
                                <FlatButton
                                  onClick={() => {
                                    setCoworkerFormState({
                                      coworker: null,
                                      mode: "Create",
                                    });
                                  }}
                                >
                                  Add Co-Worker
                                </FlatButton>
                              </ACL>
                            ),
                          }}
                          syncWithUrl={true}
                          footer={{ paginator: { enable: true, limits: [10] } }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Modal
        show={modalState === "pop-up"}
        size="2xl"
        popup
        onClose={() => closeModal()}
      >
        <Modal.Header />
        <Modal.Body>
          <div className="flex flex-row flex-nowrap items-center">
            {qrCode && (
              <>
                <img className="h-13 w-13" src={qrCode.qr} alt="" />
                <h3 className="mb-5 ml-4 text-md font-normal text-gray-500 dark:text-gray-500">
                  Coworker has been created successfully.
                  <br />
                  <br /> Please Scan the QR Code with Google Authenticator and
                  Save this Secret key to recover account incase if lost.
                  <br />
                  <p
                    className="cursor-pointer text-blue-500 text-underline"
                    onClick={() => {
                      window.open(qrCode.qr);
                    }}
                  >
                    Click here
                  </p>{" "}
                  to open QR Code in new tab <br />
                  <br />
                  <b className="font-bold text-md ">
                    SECRET KEY:
                    <br /> ${qrCode.secret_key}
                  </b>
                </h3>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <ACL showFor={[SUPERADMIN]}>
        <Popup
          header={`${coworkerFormState?.mode} Coworker`}
          onConfirm={() => coworkerForm.submitForm()}
          onClose={coworkerForm.resetForm}
          onCancel={coworkerForm.resetForm}
          modalState={[formModalState, setFormModalState]}
          confirmText={`${coworkerFormState?.mode} Coworker`}
          size="4xl"
          alignActions="end"
          content={
            <CoworkerForm
              formik={coworkerForm}
              mode={coworkerFormState?.mode}
            />
          }
        />
      </ACL>
    </main>
  );
}

export default Coworkers;
